import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../../globals";
import { ProductsServices } from "../../../../services";

@Component({
    selector: 'page-product-partial-wfoodcost-tags',
    templateUrl: 'product-partial-wfoodcost-tags.html',
})
export class ProductPartialWfoodcostTagsPage {
    show_product_tags = false;
    product_tags_filtered = [];

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public productsServices: ProductsServices) {

    }

    onChange(val) {
        this.productsServices.product_tags = val || [];
    }

    addTag(tag) {
        // Asegurar que product_tags sea un array
        if (!this.productsServices.product_tags) {
            this.productsServices.product_tags = [];
        }
        
        if (!(this.productsServices.product_tags.indexOf(tag) > -1)) {
            if (tag != 'eti') {
                this.productsServices.product_tags.push(tag);
                this.show_product_tags = false;
                this.product_tags_filtered = [];
            }
        }
    }

    onInputChange(event: any) {
        const valorInput = event.target.value;
        if (valorInput) {
            this.show_product_tags = true;
            this.product_tags_filtered = this.globals.tags_all.filter(tag =>
                tag.toLowerCase().includes(valorInput.toLowerCase()));
            this.product_tags_filtered.sort((one, two) => (one.toLowerCase() < two.toLowerCase() ? -1 : 1));
        } else {
            this.show_product_tags = false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-info/product-partial-wfoodcost-tags/product-partial-wfoodcost-tags.ts